module.exports = __webpack_public_path__ + "img/close_icon.ee636d80.svg";